module.exports = __webpack_public_path__ + "static/media/return-on-investment.48c7d346.svg";